import {
	Alert,
	Box,
	Button,
	Chip,
	Fade,
	FormHelperText,
	Grid,
	IconButton,
	Input,
	Modal,
	Paper,
	Popper,
	Snackbar,
} from '@mui/material';
import { GridAddIcon } from '@mui/x-data-grid';
import CancelIcon from '@mui/icons-material/Cancel';
import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
import {
	Add,
	Close,
	Delete,
	DeleteForever,
	Edit,
	RemoveCircleOutline,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {
	getPatientList,
	getUserSettings,
	postUserSettings,
	updateUserSettings,
} from '../../../services/api/apiManager';
import { ClearIcon } from '@mui/x-date-pickers-pro';

function FavouritePatientList() {
	const practiceID = localStorage.getItem('practice_id');
	const [loading, setLoading] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [addListAnchorEl, setAddListAnchorEl] = useState(null);
	const [settingID, setSettingID] = useState(0);
	const [addSettingName, setAddSettingName] = useState('');
	const [favouritePatientList, setFavouritePatientList] = useState([]);
	const [patientList, setPatientList] = useState([]);
	const [selectedPatient, setSelectedPatient] = useState([]);
	const [currentOpennedSettingPatients, setCurrentOpennedSettingPatients] =
		useState([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [editFavouritePatientListDialog, setEditFavouritePatientListDialog] =
		useState(false);
	// WARNING! I am using same modal for delete and rename the setting name
	const [deleteOrEditModal, setDeleteOrEditModal] = useState({
		open: false,
		settingName: '',
		modalFor: '',
	});
	// warning I am using Same Snackbar for add,update,delete
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [snackbarInfo, setSnackbarInfo] = useState({
		snackbarMsg: '',
		snackbarColor: '',
	});

	const handleChange = function (accordianID) {
		return function (event, isExpanded) {
			return setExpanded(isExpanded ? accordianID : false);
		};
	};

	// function which is used to retrieve all favourite patient list from our settingslist
	const getUserSetting = async () => {
		setLoading(true);
		try {
			const resp = await getUserSettings();
			if (resp?.status === 200) {
				setFavouritePatientList(
					resp?.data
						?.filter((items) => {
							return (
								items?.practice_id === parseInt(practiceID) &&
								(items?.Type === 'PAT' || items?.Type === 'pat')
							);
						})
						?.reverse()
				);

				setLoading(false);
			} else {
				setFavouritePatientList([]);
			}
		} catch (error) {
			console.log(`ERROR-->`, error);
		}
	};

	const getAllPatientList = async (practiceID) => {
		const resp = await getPatientList(practiceID);
		if (resp.status === 200 || resp.status === 201) {
			setPatientList(resp?.data);
		} else {
			setPatientList([]);
		}
	};

	// function for aading new User Settings Name
	const addUserSetting = async (data) => {
		const resp = await postUserSettings(data);
		if (resp?.status === 201) {
			getUserSetting();
			setAddSettingName('');
			setSnackbarInfo({ snackbarColor: 'green', snackbarMsg: 'new' });
		} else {
			setSnackbarInfo({ snackbarColor: 'red', snackbarMsg: 'error' });
		}
		setOpenSnackbar(true);
	};

	const updateUserSetting = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			getUserSetting();
			setExpanded(false);
			setAddSettingName('');
			setSelectedPatient([]);
			setCurrentOpennedSettingPatients([]);
			setSnackbarInfo(
				resp?.data?.Deleted === true
					? { snackbarColor: 'green', snackbarMsg: 'delete' }
					: { snackbarColor: 'green', snackbarMsg: 'update' }
			);
		} else {
			setSnackbarInfo({ snackbarColor: 'red', snackbarMsg: 'error' });
		}
		setOpenSnackbar(true);
	};

	const DeleteFavouriteListPatient = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			setSnackbarInfo({ snackbarColor: 'green', snackbarMsg: 'delete' });
			//for getting all user setting details I can call getUserSetting()  function again here but there was loader in it and i dont want that loader
			const resp = await getUserSettings();
			setFavouritePatientList(
				resp?.data
					?.filter((items) => {
						return (
							items?.practice_id === parseInt(practiceID) &&
							(items?.Type === 'PAT' || items?.Type === 'pat')
						);
					})
					?.reverse()
			);
		}
		setOpenSnackbar(true);
	};
	useEffect(() => {
		getUserSetting();
		getAllPatientList(practiceID);
	}, []);
	const filterPatient = patientList?.filter((options) => {
		return options?.Inactive !== false && options?.Inactive !== null;
	});

	const [searchFavPatient, setSearchFavPatient] = useState('');
	const filterFavPatient = favouritePatientList?.filter((items) => {
		return (
			searchFavPatient === '' ||
			items?.SettingName?.toLowerCase().includes(searchFavPatient.toLowerCase())
		);
	});
	return (
		<>
			{loading ? (
				<div
					style={{
						width: '100%',
						height: '80vh',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<div className="logo-container">
						<img
							className="logo"
							style={{ width: '70%' }}
							src={WebLogo}
							alt="Website Logo"
						/>
					</div>
				</div>
			) : (
				<>
					<Box
						width={'100%'}
						height={'50px'}
						display={'flex'}
						justifyContent={'space-between'}
						alignItems={'center'}
					>
						<Box display={'flex'}>
							<TextField
								placeholder="Search Patient..."
								variant="outlined"
								size="small"
								value={searchFavPatient}
								onChange={(event) => {
									setSearchFavPatient(event.target.value);
								}}
								InputProps={{
									style: {
										height: '35px',
										borderRadius: '0.5rem',
										borderLeft: '4px solid #008CD1',
									},
								}}
								sx={{
									'& input': {
										color: '#6C6767',
										letterSpacing: '0.3px',
										fontSize: '15px',
										fontFamily: 'initial',
										lineHeight: '13.31px',
										borderRadius: '14px',
										height: '16px',
									},
									'& .MuiOutlinedInput-root': {
										'& fieldset': {
											borderRadius: '4px', // default border radius
											borderColor: '#D3D3D3', // default border color before focus or hover
										},
										'&.Mui-focused fieldset': {
											borderColor: '#148086', // border color when focused
										},
										'&:hover fieldset': {
											borderColor: '#1976d2', // border color on hover
										},
									},
								}}
							/>
							<IconButton
								sx={{
									bgcolor: '#008CD1',
									borderRadius: '0px 4px 4px 0px',
									color: 'white',
									width: '20%',
									height: '35px',
									'&:hover': {
										bgcolor: '#008CD1',
									},
								}}
							>
								<SearchIcon />
							</IconButton>
						</Box>
						<Button
							variant="contained"
							sx={{ background: '#00A2E8', color: 'white', fontSize: '12px' }}
							startIcon={<GridAddIcon />}
							onClick={(event) => {
								setAddListAnchorEl((prevaAnchorEl) =>
									prevaAnchorEl ? null : event.currentTarget
								);
							}}
						>
							Add List
						</Button>
					</Box>
					{!favouritePatientList?.length > 0 ? (
						<>
							<Box
								width={'100%'}
								height={'45vh'}
								display={'flex'}
								justifyContent={'center'}
								alignItems={'center'}
							>
								<Box>
									<span
										style={{
											color: '#0D406F',
											width: '200px',
											margin: 'auto',
											fontWeight: 600,
										}}
									>
										0
									</span>
									&nbsp;
									<span style={{ fontWeight: 600 }}> Record</span>
								</Box>
							</Box>
						</>
					) : (
						<Grid
							container
							height={'65vh'}
							border={'1px solid lightgray'}
							p={1}
							borderRadius={2}
							overflow={'auto'}
						>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								{filterFavPatient?.map((items, index) => {
									return (
										<Grid container key={items?.id} mt={index === 0 ? 0 : 1}>
											<Grid xs={9} sm={9} md={9} xl={9} lg={9}>
												<Box>
													<Accordion
														disableGutters
														expanded={expanded == items?.id}
														onChange={(event, isExpanded) => {
															handleChange(items?.id)(event, isExpanded); //it is nested function of MUI AutoComplete so I am passing outer function parameter in first () and inner function parameter in secound()
															if (isExpanded) {
																setCurrentOpennedSettingPatients(
																	items?.setting_codes
																);
															} else {
																setCurrentOpennedSettingPatients([]);
															}
														}}
														slotProps={{ transition: { timeout: 500 } }}
														sx={{
															'& .MuiAccordion-region': {
																height: expanded ? 'auto' : 0,
															},
															'& .MuiAccordionDetails-root': {
																display: expanded ? 'block' : 'none',
															},
															width: '100%',
															'& .MuiButtonBase-root': {
																minHeight: '10px',
															},
														}}
													>
														<AccordionSummary
															expandIcon={<ExpandMoreIcon />}
															aria-controls={items?.id}
															id={items?.id}
															sx={{
																background: '#C5DEF6',
																display: 'flex',
																justifyContent: 'space-between',
																width: '100%',
															}}
														>
															<Typography
																sx={{
																	fontSize: {
																		xl: '15px',
																		lg: '11px',
																		md: '10px:',
																		sm: '10px',
																		xs: '10px',
																	},

																	fontWeight: '600',
																	fontFamily: 'Poppins',
																}}
															>
																{items?.SettingName}
															</Typography>
														</AccordionSummary>
														<AccordionDetails
															sx={{
																padding: '5px 20px',
																background: '#EEF5FFA8',
															}}
														>
															{currentOpennedSettingPatients?.length === 0 && (
																<>
																	<span style={{ color: 'red' }}>0 </span>
																	<span style={{ fontWeight: 600 }}>
																		Patients in this Setting
																	</span>
																</>
															)}
															<Box
																sx={{
																	wisth: '100%',
																	maxHeight: '20vh',
																	overflow: 'auto',
																}}
															>
																{currentOpennedSettingPatients?.map(
																	(innerItems, index) => (
																		<Grid
																			container
																			item
																			key={index}
																			xs={12}
																			sm={12}
																			md={12}
																			xl={12}
																			lg={12}
																			sx={{
																				display: 'flex',
																				alignItems: 'center',
																			}}
																		>
																			<Grid
																				item
																				xs={6}
																				sm={6}
																				md={6}
																				xl={6}
																				lg={6}
																				sx={{ display: 'flex', gap: '25px' }}
																			>
																				<Typography
																					sx={{
																						color: '#1D60C5',
																						fontSize: {
																							xl: '15px',
																							lg: '11px',
																							md: '10px:',
																							sm: '10px',
																							xs: '10px',
																						},

																						fontWeight: '600',
																						fontFamily: 'Poppins',
																					}}
																				>
																					{innerItems?.CodeDescription}
																				</Typography>
																			</Grid>
																			<Grid
																				item
																				xs={6}
																				sm={6}
																				md={6}
																				xl={6}
																				lg={6}
																				sx={{
																					display: 'flex',
																					justifyContent: 'flex-end',
																				}}
																			>
																				<IconButton
																					onClick={() => {
																						const afterDeleteIconClicked =
																							currentOpennedSettingPatients?.filter(
																								(items) =>
																									items?.id !== innerItems.id
																							);
																						setCurrentOpennedSettingPatients(
																							afterDeleteIconClicked
																						);
																						DeleteFavouriteListPatient(
																							items?.id,
																							{
																								setting_codes:
																									afterDeleteIconClicked,
																							}
																						);
																					}}
																				>
																					<Delete
																						sx={{
																							color: 'red',
																							fontSize: '20px',
																						}}
																					/>
																				</IconButton>
																			</Grid>
																		</Grid>
																	)
																)}
															</Box>
														</AccordionDetails>
													</Accordion>
												</Box>
											</Grid>

											<Grid
												item
												xs={1}
												sm={1}
												md={1}
												xl={1}
												lg={1}
												sx={{
													background: '#3F9943',
													// width: '100%',
													height: '42px',
													display: 'flex',
													justifyContent: 'cneter',
													alignItems: 'center',
												}}
											>
												<IconButton
													onClick={() => {
														setCurrentOpennedSettingPatients(
															items?.setting_codes
														);
														setSettingID(items?.id);
														setEditFavouritePatientListDialog(true);
													}}
													sx={{ width: '100%' }}
												>
													<Add sx={{ color: 'white' }} />
												</IconButton>
											</Grid>

											<Grid
												item
												xs={1}
												sm={1}
												md={1}
												xl={1}
												lg={1}
												sx={{
													background: '#1D60C5',
													// width: '100%',
													height: '42px',
													display: 'flex',
													justifyContent: 'cneter',
													alignItems: 'center',
												}}
												onClick={() => {
													setAddSettingName(items?.SettingName);
													setSettingID(items?.id);
													setDeleteOrEditModal({
														open: true,
														settingName: items?.SettingName,
														modalFor: 'editModal',
													});
												}}
											>
												<IconButton sx={{ width: '100%' }}>
													<Edit sx={{ color: 'white' }} />
												</IconButton>
											</Grid>
											<Grid
												item
												xs={1}
												sm={1}
												md={1}
												xl={1}
												lg={1}
												sx={{
													background: '#ED2828',
													height: '42px',
													display: 'flex',
													alignItems: 'center',
												}}
												onClick={() => {
													setDeleteOrEditModal({
														open: true,
														settingName: items?.SettingName,
													});
													setSettingID(items?.id);
												}}
											>
												<IconButton sx={{ width: '100%' }}>
													<Delete sx={{ color: 'white' }} />
												</IconButton>
											</Grid>
										</Grid>
									);
								})}
							</Grid>
						</Grid>
					)}
				</>
			)}

			{/* Add Patient to Favourite list from this Dialog */}
			<Dialog
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<Box
					sx={{
						width: '60vh',
						height: '70vh',
						overflow: 'auto',
						textAlign: 'center',
					}}
				>
					<DialogTitle id="alert-dialog-title" fontWeight={600}>
						<Box
							width={'100%'}
							height={'40px'}
							display={'flex'}
							justifyContent={'center'}
						>
							<Box
								height={'18px'}
								width={'18px'}
								bgcolor={'red'}
								display={'flex'}
								flexDirection={'column'}
								alignItems={'center'}
								justifyContent={'center'}
								borderRadius={'15px'}
								sx={{ cursor: 'pointer' }}
								onClick={() => {
									setOpenDialog(false);
									setAddSettingName('');
									setSelectedPatient([]);
								}}
							>
								{' '}
								<Close sx={{ color: 'whitesmoke', fontSize: '15px' }} />
							</Box>
							<span style={{ width: '95%' }}>Select Patient</span>
						</Box>
					</DialogTitle>

					<Box
						sx={{
							width: '100%',
							height: '70%',
							display: 'flex',
							justifyContent: 'center',
							// flex: '1',
						}}
					>
						<Autocomplete
							multiple
							size="small"
							limitTags={2}
							id="checkboxes-tags-demo"
							options={patientList}
							disableCloseOnSelect
							getOptionLabel={(option) => option?.Name}
							// i am using renderTags so i can remove selectedPatient from arrray on the the remove of textfield
							renderTags={(value, getTagProps) =>
								selectedPatient.map((items, index) => {
									return (
										<>
											<Chip
												deleteIcon={<RemoveCircleOutline />}
												onDelete={() => {
													const removeCodes = selectedPatient?.filter(
														(selectedPatients) =>
															selectedPatients?.Code !== items?.Code
													);
													setSelectedPatient(removeCodes);
												}}
												key={index}
												variant="outlined"
												label={items?.CodeDescription}
											/>
										</>
									);
								})
							}
							clearIcon={
								<ClearIcon
									fontSize="small"
									onClick={() => setSelectedPatient([])}
								/>
							}
							renderOption={(props, option, { selected }) => {
								return (
									<Box
										key={option?.patient_id}
										style={{
											fontSize: '10px',
											padding: '0px',
											margin: '0px',
											height: '15px',
										}}
										{...props}
									>
										<Checkbox
											id={option?.patient_id}
											icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
											checkedIcon={<CheckBoxIcon fontSize="small" />}
											style={{ marginRight: 8 }}
											checked={selectedPatient?.some(
												(items) => items?.Code == option?.patient_id
											)}
											sx={{ fontSize: '13px' }}
											value={option?.patient_id}
											onChange={(e) => {
												if (e.target.checked) {
													setSelectedPatient((prev) => {
														return [
															...prev,
															{
																setting_id: settingID,
																CodeType: 'pat',
																Code: e.target.value,
																CodeDescription: option?.Name,
															},
														];
													});
												} else {
													const removeCodes = selectedPatient.filter(
														(items) => items?.Code !== e.target.value
													);
													setSelectedPatient(removeCodes);
												}
											}}
										/>
										{option?.Name}
									</Box>
								);
							}}
							PaperComponent={CustomPaper}
							PopperComponent={CustomPopper}
							sx={{ width: '80%' }}
							renderInput={(params) => {
								return <TextField {...params} label="Select Patients" />;
							}}
						/>
					</Box>
					<Button
						sx={{
							background: '#ED2828',
							color: 'white',
							fontFamily: 'Poppins',
							fontSize: '13px',
							marginRight: '10px',
							'&:hover': {
								background: '#ED2828',
								color: 'white',
							},
						}}
						onClick={() => {
							setOpenDialog(false);
							setAddSettingName('');
							setSelectedPatient([]);
						}}
					>
						Cancel
					</Button>
					<Button
						disabled={selectedPatient.length === 0}
						sx={{
							background: selectedPatient.length != 0 ? '#00A2E8' : 'grey',
							color: 'white',
							fontFamily: 'Poppins',
							fontSize: '13px',
							'&:hover': {
								background: '#00A2E8',
								color: 'white',
							},
						}}
						onClick={() => {
							addUserSetting({
								practice_id: practiceID,
								Type: 'pat',
								SettingName: addSettingName,
								setting_codes: selectedPatient,
							});
							setSelectedPatient([]);
							setOpenDialog(false);
						}}
					>
						Add to favourites
					</Button>
				</Box>
			</Dialog>

			{/* Edit your Favourite Patients in the list from this dialog */}
			<Dialog
				open={editFavouritePatientListDialog}
				onClose={() => setEditFavouritePatientListDialog(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<Box
					sx={{
						width: '60vh',
						height: '70vh',
						overflow: 'auto',
						textAlign: 'center',
					}}
				>
					<DialogTitle id="alert-dialog-title" fontWeight={600}>
						<Box
							width={'100%'}
							height={'40px'}
							display={'flex'}
							justifyContent={'center'}
						>
							<Box
								height={'18px'}
								width={'18px'}
								bgcolor={'red'}
								display={'flex'}
								flexDirection={'column'}
								alignItems={'center'}
								justifyContent={'center'}
								borderRadius={'15px'}
								sx={{ cursor: 'pointer' }}
								onClick={() => {
									setExpanded(false);
									setEditFavouritePatientListDialog(false);
									setCurrentOpennedSettingPatients([]);
								}}
							>
								{' '}
								<Close sx={{ color: 'whitesmoke', fontSize: '18px' }} />
							</Box>
							<span style={{ width: '95%' }}>Select Patient</span>
						</Box>
					</DialogTitle>

					<Box
						sx={{
							width: '100%',
							height: '70%',
							display: 'flex',
							justifyContent: 'center',
							// flex: '1',
						}}
					>
						<Autocomplete
							multiple
							size="small"
							limitTags={2}
							id="checkboxes-tags-updateFavPatList"
							options={patientList?.filter((options) => {
								return options?.Inactive !== true;
							})}
							// options={patientList}
							disableCloseOnSelect
							getOptionLabel={(option) => option?.Name}
							defaultValue={['']} //i am passing array with one length so when the user open for updates our currentOpennedSettingPatients  values shown here by default with help of renderTags other wise they not shown until we checked any one checkbox
							renderTags={(value, getTagProps) =>
								currentOpennedSettingPatients.map((items, index) => {
									return (
										<>
											<Chip
												deleteIcon={<RemoveCircleOutline />}
												onDelete={() => {
													const removeCodes =
														currentOpennedSettingPatients?.filter(
															(selectedPatients) =>
																selectedPatients?.Code !== items?.Code
														);
													setCurrentOpennedSettingPatients(removeCodes);
												}}
												key={index}
												variant="outlined"
												label={items?.CodeDescription}
											/>
										</>
									);
								})
							}
							clearIcon={
								<ClearIcon
									fontSize="small"
									onClick={() => setCurrentOpennedSettingPatients([])}
								/>
							}
							renderOption={(props, option, { selected }) => {
								return (
									<Box
										style={{
											fontSize: '10px',
											padding: '0px',
											margin: '0px',
											height: '15px',
										}}
										{...props}
									>
										<Checkbox
											id={option?.patient_id}
											icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
											checkedIcon={<CheckBoxIcon fontSize="small" />}
											style={{ marginRight: 8 }}
											checked={currentOpennedSettingPatients?.some(
												(items) => items?.Code == option?.patient_id
											)}
											sx={{ fontSize: '13px' }}
											value={option?.patient_id}
											onChange={(e) => {
												if (e.target.checked) {
													console.log('check Id', option?.patient_id);
													setCurrentOpennedSettingPatients((prev) => {
														return [
															...prev,
															{
																setting_id: settingID,
																CodeType: 'pat',
																Code: e.target.value,
																CodeDescription: option?.Name,
															},
														];
													});
												} else {
													const removeCodes =
														currentOpennedSettingPatients.filter(
															(items) => items?.Code !== e.target.value
														);
													setCurrentOpennedSettingPatients(removeCodes);
												}
											}}
										/>
										{option?.Name}
									</Box>
								);
							}}
							PaperComponent={CustomPaper}
							PopperComponent={CustomPopper}
							sx={{ width: '80%' }}
							renderInput={(params) => {
								return <TextField {...params} label="Select Patients" />;
							}}
						/>
					</Box>
					<Button
						sx={{
							background: '#ED2828',
							color: 'white',
							fontFamily: 'Poppins',
							fontSize: '13px',
							marginRight: '10px',
							'&:hover': {
								background: '#ED2828',
								color: 'white',
							},
						}}
						onClick={() => {
							setExpanded(false);
							setEditFavouritePatientListDialog(false);
							setAddSettingName('');
							setCurrentOpennedSettingPatients([]);
						}}
					>
						Cancel
					</Button>
					<Button
						disabled={currentOpennedSettingPatients.length === 0}
						sx={{
							background:
								currentOpennedSettingPatients.length != 0 ? '#00A2E8' : 'grey',
							color: 'white',
							fontFamily: 'Poppins',
							fontSize: '13px',
							'&:hover': {
								background: '#00A2E8',
								color: 'white',
							},
						}}
						onClick={() => {
							updateUserSetting(settingID, {
								setting_codes: currentOpennedSettingPatients,
							});
							setCurrentOpennedSettingPatients([]);
							setEditFavouritePatientListDialog(false);
							setExpanded(false);
						}}
					>
						Update Favourite Patient List
					</Button>
				</Box>
			</Dialog>
			{/* Add list Popper */}
			<Popper
				sx={{ zIndex: 9 }}
				id={'add-list-popper'}
				open={addListAnchorEl}
				anchorEl={addListAnchorEl}
			>
				<Box
					sx={{
						borderRadius: '5px',
						boxShadow: '3px 3px 3px 3px #00000040',
						padding: '10px 15px',
						background: '#FFFFFF',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							gap: '7px',
							alignItems: 'center',
							marginBottom: '7px',
						}}
					>
						<IconButton
							onClick={() => {
								setAddListAnchorEl(null);
								setAddSettingName('');
							}}
							aria-describedby={'add-list-popper'}
							color="#ED2828"
						>
							<Close sx={{ color: '#ED2828' }} />
						</IconButton>
						<Typography
							variant="body2"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '18px',
								fontWeight: 500,
								textAlign: 'center',
								color: 'black',
							}}
						>
							Add Name
						</Typography>
					</Box>
					<Input
						id="settingNameField"
						disableUnderline
						type="text"
						fullWidth
						value={addSettingName}
						onChange={(e) => setAddSettingName(e.target.value)}
						placeholder="Enter List Name"
						sx={{
							borderRadius: '6px',
							border: '1px solid #383838',
							padding: '5px',
							marginBottom: '7px',
						}}
					/>
					{addSettingName === '' && (
						<FormHelperText
							sx={{ color: 'red' }}
						>{`Name should\'t be Empty`}</FormHelperText>
					)}
					<Box sx={{ display: 'flex', justifyContent: 'center' }}>
						<Button
							disabled={addSettingName === ''}
							onClick={() => {
								setAddListAnchorEl(null);
								setOpenDialog(true);
							}}
							sx={{
								width: '97px',
								height: '42px',
								bgcolor: `${addSettingName !== '' ? '#00A2E8' : 'grey'}`,
								borderRadius: '6px',
								border: '1px solid white',
								color: '#FFFFFF',
								'&:hover': {
									background: '#00A2E8',
								},
							}}
						>
							Proceed
						</Button>
					</Box>
				</Box>
			</Popper>

			{/* delete and edit setting name Moal */}
			{/* WARNING! I am using same modal for delete and rename the setting name and using conditional renderings for delete button and edit button  */}
			<Modal
				open={deleteOrEditModal?.open}
				onClose={() => {
					setDeleteOrEditModal({ open: false });
				}}
				aria-labelledby="delete-modal-title"
				aria-describedby="delete-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: '30%',
						backgroundColor: 'white',
						border: ' 1px solid #00000026',
						borderRadius: '12px',
					}}
				>
					<Grid
						container
						item
						lg={12}
						xs={12}
						md={12}
						sm={12}
						xl={12}
						// justifyContent="center"
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							borderBottom: '1px solid #00000070',
						}}
					>
						<Grid
							item
							lg={1}
							xs={1}
							md={1}
							sm={1}
							xl={1}
							sx={{
								// width: '100%',
								display: 'flex',
								justifyContent: 'flex-start',
							}}
						>
							<IconButton
								onClick={() => {
									setDeleteOrEditModal({ open: false });
									setAddSettingName('');
								}}
							>
								<CancelIcon
									sx={{
										fontSize: {
											xs: '10px',
											sm: '10px',
											md: '20px',
											lg: '20px',
											xl: '20px',
										},
									}}
									color="error"
								/>
							</IconButton>
						</Grid>

						<Grid
							item
							lg={11}
							xs={11}
							md={11}
							sm={11}
							xl={11}
							sx={{
								// width: '100%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontSize: {
										xs: '10px',
										sm: '10px',
										md: '14px',
										lg: '15px',
										xl: '16px',
									},
									fontWeight: 500,
								}}
							>
								{deleteOrEditModal.modalFor === 'editModal'
									? `Update List Name`
									: `Delete Custom List`}
							</Typography>
						</Grid>
					</Grid>
					<Box width={'100%'}>
						<Typography
							textAlign="center"
							mt={1}
							sx={{
								fontFamily: 'Poppins',
								fontWeight: '500',
								fontSize: {
									xs: '10px',
									sm: '10px',
									md: '16px',
									lg: '16px',
									xl: '16px',
								},
							}}
						>
							{' '}
							{deleteOrEditModal.modalFor === 'editModal'
								? ``
								: `Are you sure you want to delete ?`}
						</Typography>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<Typography
								textAlign="center"
								mt={1}
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: {
										xs: '10px',
										sm: '10px',
										md: '18px',
										lg: '18px',
										xl: '18px',
									},
									color: '#075AD7',
								}}
							>
								{deleteOrEditModal.modalFor === 'editModal' ? (
									<TextField
										id="settingNameField"
										disableUnderline
										label="Update List Name"
										size="small"
										type="text"
										fullWidth
										value={addSettingName}
										onChange={(e) => setAddSettingName(e.target.value)}
										placeholder="Update List Name"
										sx={{
											borderRadius: '6px',
											// border: '1px solid #383838',
											// padding: '5px',
											// marginBottom: '7px',
										}}
									/>
								) : (
									deleteOrEditModal?.settingName
								)}
							</Typography>
						</Box>
					</Box>
					<Box
						mt={1}
						width={'100%'}
						display={'flex'}
						sx={{
							// flexDirection: {
							// 	xs: 'column',
							// 	sm: 'column',
							// 	md: 'row',
							// 	lg: 'row',
							// 	xl: 'row',
							// },
							padding: '10px',
						}}
						alignItems={'center'}
						justifyContent={'center'}
						gap={1}
					>
						<Button
							onClick={() => {
								setDeleteOrEditModal({ open: false });
								setAddSettingName('');
							}}
							style={{
								backgroundColor: '#ED2828',
								width: '80px',
								height: '30px',
								borderRadius: '7px',
								color: '#FFFFFF',
								fontSize: '14px',
							}}
						>
							Cancel
						</Button>

						{deleteOrEditModal.modalFor === 'editModal' ? (
							<Button
								style={{
									backgroundColor: '#00A2E8',
									width: '80px',
									height: '30px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '14px',
								}}
								onClick={() => {
									updateUserSetting(settingID, {
										SettingName: addSettingName,
									});
									setDeleteOrEditModal({ open: false });
								}}
							>
								Rename
							</Button>
						) : (
							<Button
								style={{
									backgroundColor: '#00A2E8',
									width: '80px',
									height: '30px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '14px',
								}}
								onClick={() => {
									updateUserSetting(settingID, {
										Deleted: true,
									});
									setDeleteOrEditModal({ open: false });
								}}
							>
								Delete
							</Button>
						)}
					</Box>
				</Box>
			</Modal>
			<Snackbar
				open={openSnackbar}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={() => setOpenSnackbar(false)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={() => setOpenSnackbar(false)}
					severity={snackbarInfo.snackbarColor === 'red' ? 'error' : 'success'}
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					{snackbarInfo.snackbarMsg === 'new'
						? `New Favourite Patient Setting Added Successfully!`
						: snackbarInfo.snackbarMsg === 'update'
							? ` Updated Successfully!`
							: snackbarInfo.snackbarMsg === 'delete'
								? `Deleted SuccessFully!`
								: openSnackbar.snackbarFor === 'error'
									? 'ERROR!'
									: ''}
				</Alert>
			</Snackbar>
		</>
	);
}

export default FavouritePatientList;

// popers and paper MUI functions
const CustomPaper = (props) => {
	return (
		<Paper
			{...props}
			sx={{
				borderRadius: 2,
				height: '10%',
				overflow: 'auto',
				'&amp; .MuiAutocomplete-listbox': {
					// maxHeight: '100%',
					padding: 1,
					'&amp; .MuiAutocomplete-option': {
						minHeight: 48,
						padding: '10px 16px',
						'&amp;[aria-selected="true"]': {
							backgroundColor: '#3F9943',
							color: 'white',
						},
						'&amp;[data-focus="true"]': {
							backgroundColor: '#d0f0d0',
						},
					},
				},
			}}
		/>
	);
};

const CustomPopper = (props) => (
	<Popper
		{...props}
		sx={{
			zIndex: 1500,
		}}
	/>
);
